import React, { ButtonHTMLAttributes, ReactNode, useMemo } from "react";
import { styleForWidth, Width } from "../../common/element/Width";

export const SecondaryButton = React.memo(function SecondaryButton(props: ButtonHTMLAttributes<any> & Props) {
    const { children, width, leading, trailing, ...rest } = props;

    const buttonStyle = useMemo(() => styleForWidth(width ?? "intrinsic"), [width]);

    return (
        <button className={"secondary_button"} style={buttonStyle} {...rest}>
            <span className={"focus"}>
                {leading && <span className={"leading"}>{leading}</span>}
                <span className={"text"}>{children}</span>
                {trailing && <span className={"trailing"}>{trailing}</span>}
            </span>
        </button>
    );
});

type Props = {
    width?: Width,
    leading?: ReactNode,
    trailing?: ReactNode,
};
